var React = require('react');

function Playstore (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.9706 17.908L24.5293 13.3493L9.80484 5.07362C8.82896 4.54637 7.91475 4.47237 7.11309 5.04896L19.9706 17.908ZM25.3063 23.2452L30.0454 20.5797C30.9704 20.0617 31.4776 19.3279 31.4776 18.5139C31.4776 17.7014 30.9704 16.966 30.0469 16.448L25.7565 14.0384L20.9264 18.8669L25.3063 23.2452ZM6.32067 6.16975C6.222 6.47346 6.1665 6.81262 6.1665 7.18417V29.8544C6.1665 30.4417 6.296 30.9474 6.53034 31.3498L19.0132 18.8654L6.32067 6.16975ZM19.9706 19.8212L7.55709 32.2362C7.7945 32.3272 8.05042 32.375 8.32021 32.375C8.80121 32.375 9.30225 32.2332 9.81255 31.9495L24.0807 23.9375L19.9706 19.8212Z","fill":"#350564"}));
}

Playstore.defaultProps = {"width":"37","height":"37","viewBox":"0 0 37 37","fill":"none"};

module.exports = Playstore;

Playstore.default = Playstore;
